import React from "react";
// components
import { Grid } from "@material-ui/core";
import { Link } from "react-router-dom";

//logo
import serviceLogo from "../../images/serviceLogo.png";
import sarLogo from "../../images/sarLogo.png";
import pollutionLogo from "../../images/pollutionLogo.png";
import DredgingIcon from "../../images/DredgingIcon.png";
import signIcon from "../../images/signIcon.jpg";
import communicationIcon from "../../images/communicationIcon.jpg";
import hydrographyIcon from "../../images/hydrographyIcon.jpg";

// style
import useStyle from "./styles";
import persianGulf from "../../images/persianGulf.jpg";

const ServiceIconContainer = ({ logo, title, des }) => {
  const classes = useStyle();

  return (
    <div className={classes.serviceIconContainer}>
      <img src={logo} alt="service logo" className={classes.serviceIconLogo} />
      <div className={classes.serviceIconTitle}>{title}</div>
      <div className={classes.serviceIconDescription}>{des}</div>
    </div>
  );
};

function Main() {
  const classes = useStyle();

  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      style={{
        padding: 25,
        background: `url(${persianGulf})`,
        backgroundSize: "cover",
      }}
    >
      <Grid
        item
        container
        direction="column"
        spacing={4}
        className={classes.iconsContainer}
      >
        <Grid item container Direction="row" spacing={4}>
          <Grid item container justify="flex-end" className={classes.item} xs>
            <Link to="/app/SAR">
              <ServiceIconContainer
                logo={sarLogo}
                title="SAR"
                des="description"
              />
            </Link>
          </Grid>
          <Grid item container justify="center" className={classes.item} xs>
            <Link to="/app/pollution">
              <ServiceIconContainer
                logo={pollutionLogo}
                title="Pollution"
                des="description"
              />
            </Link>
          </Grid>
          <Grid item container justify="flex-start" className={classes.item} xs>
            <Link to="/app/sign">
              <ServiceIconContainer
                logo={signIcon}
                title="Sign"
                des="description"
              />
            </Link>
          </Grid>
        </Grid>
        <Grid item container Direction="row" spacing={4}>
          <Grid item container justify="flex-end" className={classes.item} xs>
            <ServiceIconContainer
              logo={hydrographyIcon}
              title="Hydrography"
              des="description"
            />
          </Grid>
          <Grid item container justify="center" className={classes.item} xs>
            <ServiceIconContainer
              logo={DredgingIcon}
              title="Dredging"
              des="description"
            />
          </Grid>
          <Grid item container justify="flex-start" className={classes.item} xs>
            <ServiceIconContainer
              logo={communicationIcon}
              title="Communication"
              des="description"
            />
          </Grid>
        </Grid>
        <Grid item container Direction="row" spacing={4}>
          <Grid item container justify="center" className={classes.item} xs>
            <ServiceIconContainer
              logo={serviceLogo}
              title="Public law convention"
              des="description"
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Main;
